import axios from 'axios'
import FileSaver from 'file-saver'
import { message } from 'ant-design-vue'
import { getAccessToken } from '@/utils/auth'
export default function download(url, name) {
  // 创建一个 <a> 元素并设置它的 href 属性
  const a = document.createElement('a')
  a.href = url
  a.download = name // 设置下载文件的名称

  // 将 <a> 元素加入到 DOM 中，以便可以触发 click 事件
  document.body.appendChild(a)

  // 触发 click 事件
  a.click()

  // 移除 <a> 元素
  document.body.removeChild(a)
}

export function fileExport({ url, name, onFinally = () => {} }) {
  if (!name) name = getUrlLastWord(url)
  console.log("🚀  fileExport  name:", name)
  // 发送请求并下载文件
  axios({
    url, // 替换为你的文件下载接口
    method: 'GET',
    responseType: 'blob', // 确保响应类型是 blob
    headers: {
      Authorization: `Bearer ${getAccessToken()}`, // 携带 token
    },
  })
    .then(({ data, headers }) => {
      const contentType = headers['content-type']
      if (contentType.includes('application/json')) {
        const reader = new FileReader()
        reader.onload = () => {
          const { msg } = JSON.parse(reader.result)
          message.warn(msg)
        }
        reader.readAsText(data)
      } else {
        const blob = new Blob([data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        FileSaver.saveAs(blob, name)
      }
    })
    .catch((error) => {
      message.warn('下载文件时出错')
      console.error('下载文件时出错:', { ...error })
    })
    .finally(() => {
      onFinally()
    })
}

function getUrlLastWord(url) {
  if (!url) return ''
  return url.split('/').pop()
}
